import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';

@Component({
  selector: 'page-table-of-contents',
  templateUrl: 'table-of-contents.html',
})
export class TableOfContentsPage {

  public toc: any;

  constructor(public navCtrl: NavController, private navParams: NavParams, public events: Events) {
    this.toc = navParams.data;
  }
  selectToc(content) {
    this.events.publish('select:location', content.href);
    this.events.publish('booksDetailsModalShow', false);
  }
  ionViewDidLoad() {
  //  console.log('ionViewDidLoad TableOfContentsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/BOOK-READER/table-of-contents/table-of-contents.ts